define.alias("checkout/components/seamless-checkout/plan-card", "calendar/components/seamless-checkout/plan-card");